<template>
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container" :class="classList">
              <div class="panel panel-default">
                  <div class="modal-header">
                    <header class="panel-heading">
                      <slot name="header">
                        <h4>Modal default header</h4>
                      </slot>
                      <button @click="$emit('close')" type="button" class="btn btn-box-tool close-btn" data-widget="remove"><i class="fa fa-times"></i></button>
                    </header>
                  </div>

                <slot name="body">
                  Default body
                </slot>

                <slot name="footer">
                </slot>

              </div>
            </div>
          </div>
        </div>
      </transition>
</template>
<script>
export default {
  name: 'PanelModal',
  props: ['classList']
}
</script>
<style>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  min-width: 300px;
  float: none;
  margin: 0px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header{
  padding: 0;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
}

.modal-default-button {
  float: right;
}
.close-btn{
    top: 15px;
    right: 10px;
    position: absolute;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>